import type { FeatureConfig } from '@platform/client/features';

export default {
  routes: [],
  navigation: () => ({}),
} satisfies FeatureConfig;
